import { useState, useCallback, useEffect } from 'react'
import useMutation from '../../../../../../hooks/useMutation'
import { useVerifyCompanyDomainMutation } from '../../../../../../api/integrations'

const RESEND_COOLDOWN_SECONDS = 60

export const useDomainVerification = domain => {
  const [verificationStep, setVerificationStep] = useState('EMAIL_SENT') //  DNS_DETAILS, EMAIL_SENT, VERIFYING, VERIFIED, FAILED
  const [dnsRecords, setDnsRecords] = useState(null)

  const [error, setError] = useState(null)

  const [resendCooldownActive, setResendCooldownActive] = useState(false)
  const [resendSecondsLeft, setResendSecondsLeft] = useState(0)
  const [isInitialEmailSend, setIsInitialEmailSend] = useState(true)
  const [showEmailSuccessNotification, setShowEmailSuccessNotification] = useState(false)
  const { submit: handleVerify } = useMutation(useVerifyCompanyDomainMutation, {
    showSuccessToast: false,
    onSuccess: handleOnSuccessEmailVerification
  })
  useEffect(() => {
    setDnsRecords(null)

    setError(null)
    setResendCooldownActive(false)
    setResendSecondsLeft(0)
    setIsInitialEmailSend(true)
    setShowEmailSuccessNotification(false)
  }, [domain])

  useEffect(() => {
    let timerId
    if (resendCooldownActive && resendSecondsLeft > 0) {
      timerId = setTimeout(() => {
        setResendSecondsLeft(prev => prev - 1)
      }, 1000)
    } else if (resendCooldownActive && resendSecondsLeft === 0) {
      setResendCooldownActive(false)
    }
    return () => clearTimeout(timerId)
  }, [resendCooldownActive, resendSecondsLeft])

  const sendVerificationEmail = useCallback(
    ({ email }) => {
      handleVerify({ email })
    },
    [domain]
  )

  function handleOnSuccessEmailVerification() {
    setIsInitialEmailSend(false)
    setShowEmailSuccessNotification(true)
    setResendSecondsLeft(RESEND_COOLDOWN_SECONDS)
    setResendCooldownActive(true)
  }

  return {
    verificationStep,
    setVerificationStep,
    dnsRecords,
    error,
    setError,
    sendVerificationEmail,
    resendCooldownActive,
    resendSecondsLeft,
    isInitialEmailSend,
    showEmailSuccessNotification,
    setShowEmailSuccessNotification
  }
}
